
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-microinverter/support",
      function () {
        return require("private-next-pages/stream-microinverter/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-microinverter/support"])
      });
    }
  